import { atom, selector } from 'recoil';
import ChristmasConfig from 'utils/recoil/ChristmasConfig';

export const CHRISTMAS_INPUT = {
  AGE: '4EuuejD0ScX9syuYZk3fSK',
  SCREEN_STD: '7A84dmez5lkFAO8Uf8CK0n',
  SCREEN_SENIOR: '4z3sP9egaG8YkazvlfslLi',
  NEED_CORRECTION: '3v5D1iu24nhE1NHMr12sA1',
  CORRECTION: '5CGME4ZrsgH6wUXHNSkR9R',
  SCREEN_TIME: '33DaYMAC9eeuWBdfmKgGLs',
  FORM: '3PbA4nRzEVNvB4Sybwhg5U',
  COLOR: '6ySX2wQNioMMDLlz9RMEzH',
};

const config = {
  christmas: [
    // STEP 0 TO AGE
    {
      options: [...ChristmasConfig.STEP_0],
      input: CHRISTMAS_INPUT.AGE,
      totalQuestions: 4,
    },

    // STEP 1 kid/teenager/adult TO SCREEN STANDARD
    {
      options: [...ChristmasConfig.STEP_1_STANDARD],
      input: CHRISTMAS_INPUT.SCREEN_STD,
      totalQuestions: 4,
    },
    {
      options: [...ChristmasConfig.STEP_1_KID],
      input: CHRISTMAS_INPUT.SCREEN_STD,
      totalQuestions: 3,
    },
    // STEP 1 senior TO SCREEN SENIOR
    {
      options: [...ChristmasConfig.STEP_1_SENIOR],
      input: CHRISTMAS_INPUT.SCREEN_SENIOR,
      totalQuestions: 5,
    },

    // STEP 2 SCREEN
    {
      options: [...ChristmasConfig.STEP_2_KID],
      input: CHRISTMAS_INPUT.COLOR,
      totalQuestions: 3,
    },
    {
      options: [...ChristmasConfig.STEP_2_STANDARD],
      input: CHRISTMAS_INPUT.FORM,
      totalQuestions: 4,
    },
    {
      options: [...ChristmasConfig.STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_NO],
      input: CHRISTMAS_INPUT.FORM,
      totalQuestions: 5,
    },
    {
      options: [...ChristmasConfig.STEP_2B_CORRECTION],
      input: CHRISTMAS_INPUT.FORM,
      totalQuestions: 6,
    },
    // STEP 2A TO NEED CORRECTION
    {
      options: [...ChristmasConfig.STEP_2_SENIOR_STANDARD],
      input: CHRISTMAS_INPUT.NEED_CORRECTION,
      totalQuestions: 5,
    },
    // STEP 2B TO CORRECTION
    {
      options: [
        ...ChristmasConfig.STEP_2_SENIOR_READING,
        ...ChristmasConfig.STEP_2A_SENIOR_STANDARD_NEED_CORRECTION_YES,
      ],
      input: CHRISTMAS_INPUT.CORRECTION,
      totalQuestions: 6,
    },
    // STEP 2C TO SCREEN TIME
    {
      options: [...ChristmasConfig.STEP_2B_READING_CORRECTION],
      input: CHRISTMAS_INPUT.SCREEN_TIME,
      totalQuestions: 6,
    },
    {
      options: [...ChristmasConfig.STEP_2C_READING_CORRECTION_SCREEN_TIME],
      input: CHRISTMAS_INPUT.FORM,
      totalQuestions: 6,
    },

    // STEP 3 TO COLOR
    {
      options: [...ChristmasConfig.STEP_3_FORM],
      input: CHRISTMAS_INPUT.COLOR,
      totalQuestions: 4,
    },
    {
      options: [...ChristmasConfig.STEP_3_FORM_NEED_CORRECTION_NO],
      input: CHRISTMAS_INPUT.COLOR,
      totalQuestions: 5,
    },
    {
      options: [
        ...ChristmasConfig.STEP_3_FORM_CORRECTION,
        ...ChristmasConfig.STEP_3_FORM_NEED_CORRECTION_YES_CORRECTION,
      ],
      input: CHRISTMAS_INPUT.COLOR,
      totalQuestions: 6,
    },

    // STEP 4 TO RESULT
    {
      options: [...ChristmasConfig.STEP_4_COLOR],
      results: true,
      totalQuestions: 4,
    },
    {
      options: [...ChristmasConfig.STEP_4_COLOR_KID],
      results: true,
      totalQuestions: 3,
    },
    {
      options: [...ChristmasConfig.STEP_4_COLOR_NEED_CORRECTION_NO],
      results: true,
      totalQuestions: 5,
    },
    {
      options: [
        ...ChristmasConfig.STEP_4_COLOR_CORRECTION,
        ...ChristmasConfig.STEP_4_COLOR_NEED_CORRECTION_YES_CORRECTION,
      ],
      results: true,
      totalQuestions: 6,
    },
  ],
};

export const quizConfigState = atom({
  key: 'quizConfigState',
  default: config,
});

export const quizIdState = atom({
  key: 'quizIdState',
  default: 'christmas',
});

export const quizAnswerHistoryState = atom({
  key: 'quizAnswerHistoryState',
  default: [{}],
});

export const quizHistoryStepState = atom({
  key: 'quizHistoryStepState',
  default: 0,
});

export const currentConfigState = selector({
  key: 'currentConfigState',
  get: ({ get }) => {
    const config = get(quizConfigState);
    const id = get(quizIdState);

    return config[id];
  },
});

export const quizResultsState = atom({
  key: 'quizResultsState',
  default: [],
});

export const quizAnswersState = atom({
  key: 'quizAnswersState',
  default: {},
});

const compare = (source, ext) => {
  const keys1 = Object.keys(source);
  const keys2 = Object.keys(ext);
  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (
      (typeof ext[key] === 'string' && source[key] !== ext[key]) ||
      (Array.isArray(ext[key]) && (!source[key] || source[key]?.length === 0))
    ) {
      return false;
    }
  }
  return true;
};
export const quizInputState = selector({
  key: 'quizInputState',
  get: ({ get }) => {
    const config = get(currentConfigState);
    const answers = get(quizAnswersState);

    return config?.find((c) => {
      return !!c.options.find((o) => compare(answers, o));
    });
  },
});
